var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-detail"},[_c('organization-basic-info',{attrs:{"organization":_vm.organization},on:{"edit-organization":_vm.onOrganizationEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }